// Pricing categories data

export const pricingCategories = [
  {
    id: "personal-training",
    name: "Personal Training",
    durations: [
      {
        time: "30'",
        packages: [
          { sessions: "1", price: "80", total: "80", label: "Séance", validity: "12 mois" },
          { sessions: "10", price: "75", total: "750", label: "Séances", savings: "~6%", validity: "3 mois" },
          { sessions: "20", price: "70", total: "1400", label: "Séances", savings: "~13%", validity: "6 mois" },
          { sessions: "40", price: "65", total: "2600", label: "Séances", savings: "~19%", popular: true, validity: "12 mois" }
        ]
      },
      {
        time: "45'",
        packages: [
          { sessions: "1", price: "110", total: "110", label: "Séance", validity: "12 mois" },
          { sessions: "10", price: "105", total: "1050", label: "Séances", savings: "~5%", validity: "3 mois" },
          { sessions: "20", price: "100", total: "2000", label: "Séances", savings: "~9%", validity: "6 mois" },
          { sessions: "40", price: "95", total: "3800", label: "Séances", savings: "~14%", popular: true, validity: "12 mois" }
        ]
      },
      {
        time: "60'",
        packages: [
          { sessions: "1", price: "140", total: "140", label: "Séance", validity: "12 mois" },
          { sessions: "10", price: "135", total: "1350", label: "Séances", savings: "~4%", validity: "3 mois" },
          { sessions: "20", price: "130", total: "2600", label: "Séances", savings: "~7%", validity: "6 mois" },
          { sessions: "40", price: "125", total: "5000", label: "Séances", savings: "~11%", popular: true, validity: "12 mois" }
        ]
      }
    ]
  },
  {
    id: "duo-training",
    name: "Duo Training",
    isDuo: true,
    durations: [
      {
        time: "45'",
        packages: [
          { sessions: "1", price: "70", total: "70", label: "Séance", validity: "12 mois" },
          { sessions: "10", price: "65", total: "650", label: "Séances", savings: "~7%", validity: "3 mois" },
          { sessions: "20", price: "60", total: "1200", label: "Séances", savings: "~14%", validity: "6 mois" },
          { sessions: "40", price: "55", total: "2200", label: "Séances", savings: "~21%", popular: true, validity: "12 mois" }
        ]
      },
      {
        time: "60'",
        packages: [
          { sessions: "1", price: "80", total: "80", label: "Séance", validity: "12 mois" },
          { sessions: "10", price: "75", total: "750", label: "Séances", savings: "~6%", validity: "3 mois" },
          { sessions: "20", price: "70", total: "1400", label: "Séances", savings: "~13%", validity: "6 mois" },
          { sessions: "40", price: "65", total: "2600", label: "Séances", savings: "~19%", popular: true, validity: "12 mois" }
        ]
      }
    ]
  },
  {
    id: "ems-training",
    name: "EMS Training",
    durations: [
      {
        time: "30'",
        packages: [
          { sessions: "1", price: "90", total: "90", label: "Séance", validity: "12 mois" },
          { sessions: "10", price: "80", total: "800", label: "Séances", savings: "~11%", validity: "3 mois" },
          { sessions: "20", price: "75", total: "1500", label: "Séances", savings: "~17%", validity: "6 mois" },
          { sessions: "40", price: "70", total: "2800", label: "Séances", savings: "~22%", popular: true, validity: "12 mois" }
        ]
      },
      {
        time: "60'",
        packages: [
          { sessions: "1", price: "105", total: "105", label: "Séance", validity: "12 mois" },
          { sessions: "10", price: "100", total: "1000", label: "Séances", savings: "~5%", validity: "3 mois" },
          { sessions: "20", price: "95", total: "1900", label: "Séances", savings: "~10%", validity: "6 mois" },
          { sessions: "40", price: "90", total: "3600", label: "Séances", savings: "~14%", popular: true, validity: "12 mois" }
        ]
      }
    ]
  },
  {
    id: "ems-duo-training",
    name: "EMS Duo Training",
    isDuo: true,
    durations: [
      {
        time: "40'",
        packages: [
          { sessions: "1", price: "70", total: "70", label: "Séance", validity: "12 mois" },
          { sessions: "10", price: "65", total: "650", label: "Séances", savings: "~7%", validity: "3 mois" },
          { sessions: "20", price: "60", total: "1200", label: "Séances", savings: "~14%", validity: "6 mois" },
          { sessions: "40", price: "55", total: "2200", label: "Séances", savings: "~21%", popular: true, validity: "12 mois" }
        ]
      },
      {
        time: "60'",
        packages: [
          { sessions: "1", price: "80", total: "80", label: "Séance", validity: "12 mois" },
          { sessions: "10", price: "75", total: "750", label: "Séances", savings: "~6%", validity: "3 mois" },
          { sessions: "20", price: "70", total: "1400", label: "Séances", savings: "~13%", validity: "6 mois" },
          { sessions: "40", price: "65", total: "2600", label: "Séances", savings: "~19%", popular: true, validity: "12 mois" }
        ]
      }
    ]
  },
  {
    id: "scan-3d",
    name: "Scan 3D Styku",
    durations: [
      {
        time: "30'",
        packages: [
          { sessions: "1", price: "90", total: "90", label: "Scan", validity: "12 mois" },
          { sessions: "2", price: "80", total: "160", label: "Scans", savings: "~11%", validity: "12 mois" }
        ]
      }
    ]
  },
  {
    id: "plan-alimentaire",
    name: "Plan Alimentaire",
    singlePrice: true,
    durations: [
      {
        time: "Complet",
        packages: [
          { sessions: "1", price: "499", total: "499", label: "Plan Complet", description: "Analyse personnalisée + suivi nutritionnel complet" }
        ]
      }
    ]
  },
  {
    id: "hypoxie-fitsonic",
    name: "Hypoxie / Fitsonic",
    isSubscription: true,
    hasTiers: true,
    durations: [
      {
        time: "SILVER",
        tier: "silver",
        subtitle: "2 séances/semaine",
        packages: [
          { sessions: "3 mois", price: "350", total: "1050", label: "/mois", perSession: "~44" },
          { sessions: "6 mois", price: "300", total: "1800", label: "/mois", perSession: "~37.50", popular: true },
          { sessions: "12 mois", price: "250", total: "3000", label: "/mois", perSession: "~31.25" }
        ]
      },
      {
        time: "GOLD",
        tier: "gold",
        subtitle: "3 séances/semaine",
        packages: [
          { sessions: "3 mois", price: "450", total: "1350", label: "/mois", perSession: "~37" },
          { sessions: "6 mois", price: "400", total: "2400", label: "/mois", perSession: "~33", popular: true },
          { sessions: "12 mois", price: "350", total: "4200", label: "/mois", perSession: "~29" }
        ]
      }
    ]
  },
  {
    id: "coaching-hybride",
    name: "Coaching Hybride",
    isHybrid: true,
    isMonthly: true,
    minDuration: "6 mois (24 semaines)",
    note: "Programme complet — engagement 6 mois",
    durations: [
      {
        time: "PROGRAMME 6 MOIS",
        tier: "hybride",
        subtitle: "Tout inclus — accompagnement présentiel + en ligne",
        packages: [
          {
            sessions: "6 mois",
            price: "399",
            total: "2394",
            label: "/mois",
            perSession: "Engagement total",
            popular: true,
            includes: [
              "🧬 Scan 3D Styku initial (30 min) + analyse de tes résultats",
              "🏋️ 6 séances coaching présentiel 60 min (3 au début du programme, 3 sur les 12 semaines suivantes)",
              "📱 Programme musculation ET cardio personnalisé sur l'app (IA, manuel ou par Laurent), évolutif sur 24 semaines",
              "🥗 Plan nutrition personnalisé + suivi macros + 180 recettes hyperprotéinées sur l'app",
              "💬 Suivi WhatsApp hebdomadaire (questions, ajustements, motivation)",
              "📊 Scan 3D Styku final (30 min) — analyse avant/après complète",
            ],
          },
        ],
      },
    ],
  },
  {
    id: "coaching-online",
    name: "Coaching 100% en ligne",
    isOnline: true,
    isMonthly: true,
    minDuration: "6 mois minimum",
    note: "Programme premium 100% à distance",
    durations: [
      {
        time: "PROGRAMME EN LIGNE",
        tier: "online",
        subtitle: "Coaching premium accessible partout dans le monde",
        packages: [
          {
            sessions: "6 mois",
            price: "299",
            total: "1794",
            label: "/mois",
            perSession: "Sans engagement présentiel",
            popular: true,
            includes: [
              "🎥 1 Zoom on-boarding 60 min (objectifs, historique, photos, mesures)",
              "📅 1 Zoom 30 min/mois — suivi & ajustements du programme",
              "📱 Programme musculation ET cardio personnalisé sur l'app (IA, manuel ou par Laurent), vidéos d'exécution Sora 2",
              "🥗 Plan nutrition personnalisé + suivi macros + 180 recettes hyperprotéinées sur l'app",
              "💬 Suivi WhatsApp 7/7 avec ton coach",
              "📈 Bilan mensuel avec photos comparatives + adaptation programme",
            ],
          },
        ],
      },
    ],
  },
  {
    id: "communaute",
    name: "Communauté Body-Up",
    isOnline: true,
    isMonthly: true,
    minDuration: "Sans engagement",
    note: "Programme app + coach, 100% en ligne",
    durations: [
      {
        time: "COMMUNAUTÉ BODY-UP",
        tier: "communaute",
        subtitle: "L'app Body-Up + votre coach, sans engagement",
        packages: [
          {
            sessions: "1 mois",
            price: "49",
            total: "49",
            label: "/mois",
            perSession: "Sans engagement · résiliable à tout moment",
            includes: [
              "📱 Accès complet à l'app Body-Up (suivi, macros, scan IA, 180 recettes hyperprotéinées)",
              "🏋️ Programme de musculation ET cardio 100% personnalisé (par Laurent)",
              "🥗 Plan nutrition 100% personnalisé, renouvelé chaque mois",
              "💬 Questions à ton coach 1×/semaine via l'app",
              "🎁 Option annuelle disponible : 2 mois offerts",
            ],
          },
        ],
      },
    ],
  }
];
